import { render, staticRenderFns } from "./ThgFrequentlyAskedQuestions.vue?vue&type=template&id=27b7846c&scoped=true"
import script from "./ThgFrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
export * from "./ThgFrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
import style0 from "./ThgFrequentlyAskedQuestions.vue?vue&type=style&index=0&id=27b7846c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7846c",
  null
  
)

export default component.exports